import { Component } from "../components/index"
import { qsa, qs, bounds } from "../utils/index"
import { gsap } from "../libraries/gsap/index"

export default class Search extends Component {
  constructor(obj) {
    super(obj)

    this.icon = qs("#trigger-search", this.el)
    this.searchForm = qs(".search-input-form", this.el)
    this.backdrop = qs(".search-backdrop", this.el)
    this.searchInput = qs(".search-input", this.el)
    this.searchModalActive = false
    this.closeModal = qs(".search-input-close", this.searchForm)
    this.resultsContainer = qs("#search-results", this.el)
  }

  on() {
    this.icon.addEventListener("click", this.toggleSearchModal)
    this.backdrop.addEventListener("click", this.toggleSearchModal)
    this.searchForm.addEventListener("submit", this.onSubmit)
    this.closeModal.addEventListener("click", this.toggleSearchModal)
  }

  off() {
    this.icon.removeEventListener("click", this.toggleSearchModal)
    this.backdrop.removeEventListener("click", this.toggleSearchModal)
    this.searchForm.removeEventListener("submit", this.onSubmit)
    this.closeModal.removeEventListener("click", this.toggleSearchModal)
  }

  onSubmit = async (e, form) => {
    e.preventDefault()

    const searchTerm = this.searchInput.value.trim()

    this.getSearchResults(searchTerm)
  }

  getSearchResults = searchTerm => {
    fetch(`/search?q=${encodeURIComponent(searchTerm)}`)
      .then(response => {
        if (!response.ok) throw new Error(response.status)
        return response.text()
      })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html")
        // console.log(doc)
        const results = doc.querySelectorAll(".search-result-item")

        // reset the result UI
        this.resultsContainer.innerHTML = ""

        // show the result UI
        this.resultsContainer.classList.toggle("search-results_active")

        // append the new results, based on the result doc (this structure can be changed in main-search-product-grid.liquid)
        results.forEach(el => this.resultsContainer.appendChild(el.cloneNode(true)))
      })
      .catch(console.error)
  }

  toggleSearchModal = () => {
    this.searchModalActive = !this.searchModalActive
    this.searchForm.classList.toggle("search-input-form_active")
    this.backdrop.classList.toggle("search-backdrop_active")

    if (this.searchModalActive === true) {
      // is open
    } else {
      // is close
      this.resultsContainer.classList.remove("search-results_active")
    }
  }
}
